// src/polyfills/cryptoUUID.ts

if (typeof crypto.randomUUID !== 'function') {
  Object.defineProperty(crypto, 'randomUUID', {
    value: () => {
      const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      const uuid = template.replace(/[xy]/g, (char) => {
        const random = (crypto.getRandomValues(new Uint8Array(1))[0] % 16) | 0
        const value = char === 'x' ? random : (random & 0x3) | 0x8
        return value.toString(16)
      })
      return uuid as `${string}-${string}-${string}-${string}-${string}`
    },
    writable: false,
    configurable: false,
  })
}

export {}
